import React from "react";
import Modal from "components/blocks/Modal/Modal";
import "./IdleTimerModals.css";

interface IdleTimerModalsProps {
  idleSecondsRemaining: number;
  isImpersonation: boolean;
  isRefreshingToken: boolean;
  isTokenExpired: boolean;
  isTokenWarningVisible: boolean;
  modalCollapsed: boolean;
  tokenSecondsRemaining: number;
  onContinueIdleSession: () => void;
  onRefreshToken: () => Promise<void>;
}

/** Convierte segundos al formato legible minutos:segundos. */
const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

/** Presenta el modal correspondiente al estado de inactividad o expiración. */
const IdleTimerModals: React.FC<IdleTimerModalsProps> = ({
  idleSecondsRemaining,
  isImpersonation,
  isRefreshingToken,
  isTokenExpired,
  isTokenWarningVisible,
  modalCollapsed,
  tokenSecondsRemaining,
  onContinueIdleSession,
  onRefreshToken,
}) => (
  <>
    {isTokenWarningVisible && !isImpersonation && (
      <Modal collapsed={false} position={99999}>
        <div className="c-center">
          <p className="message-idle-session">
            <span className="message-idle-session__em d-block mb-4 message-sub-modal">
              Su sesión está a punto de expirar
            </span>
            <span className="d-block message-sub-modal">
              La sesión se cerrará en
            </span>
            <span className="message-idle-session__em token-expiration-countdown d-block">
              {formatTime(tokenSecondsRemaining)}
            </span>
          </p>
          <div className="mt-4">
            <button
              className="btn-box btn-accent"
              onClick={onRefreshToken}
              disabled={isRefreshingToken}
            >
              {isRefreshingToken ? "Renovando..." : "Continuar sesión"}
            </button>
          </div>
        </div>
      </Modal>
    )}

    {!isTokenExpired &&
      !isImpersonation &&
      !modalCollapsed &&
      !isTokenWarningVisible && (
        <Modal collapsed={modalCollapsed} position={99999}>
          <div className="c-center">
            <p className="message-idle-session">
              <span className="message-idle-session__em d-block mb-4">
                ¿Continúa conectado?
              </span>
              <span className="d-block message-sub-modal">
                Su sesión va a expirar en
              </span>
              <span className="message-idle-session__em token-expiration-countdown d-block">
                {formatTime(idleSecondsRemaining)}
              </span>
            </p>
            <div className="mt-4">
              <button
                className="btn-box btn-accent"
                onClick={onContinueIdleSession}
              >
                Continuar sesión
              </button>
            </div>
          </div>
        </Modal>
      )}

    {isImpersonation && isTokenExpired && !modalCollapsed && (
      <Modal collapsed={modalCollapsed} position={99999}>
        <div className="c-center">
          <p className="message-idle-session">
            <span className="message-idle-session__em d-block mb-4">
              Su Sesión ha Expirado
            </span>
            <span className="message-idle-session__em d-block mb-4">
              Cierre o refresque la ficha del paciente para reactivar el visor
              del Portal Paciente
            </span>
          </p>
        </div>
      </Modal>
    )}
  </>
);

export default IdleTimerModals;
